import { render } from "./list-branch.vue?vue&type=template&id=36b6f067&scoped=true"
import script from "./list-branch.vue?vue&type=script&lang=js"
export * from "./list-branch.vue?vue&type=script&lang=js"

import "./list-branch.vue?vue&type=style&index=0&id=36b6f067&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b6f067"]])

export default __exports__